import classNames from 'classnames';

import * as Styles from './TopCompanyLabel.styles';

const TopCompanyLabel = ({ label, className }) => {
  if (!label) {
    return null;
  }

  return (
    <Styles.Wrapper className={classNames(className)}>{label}</Styles.Wrapper>
  );
};

export default TopCompanyLabel;
